import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarDepartamentos(axios) {        
    let parametros = {
      operacao: 'buscarDepartamentos'
    }

    let retorno = {};

    await axios.santriGET('/rest/departamento', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;  
  },

  async buscarDepartamentosSugestao(axios) {        
    let parametros = {
      operacao: 'buscarDepartamentosSugestao'
    }

    let retorno = {};

    await axios.santriGET('/rest/departamento', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;  
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RDepartamento.js